import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { motion } from "framer-motion";

const Leasing = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#ffffff",
        py: 8,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "80%" }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
                fontWeight: "bold",
                color: "#004aad",
                mb: 2,
              }}
            >
              Arrendamiento de Equipos y Materiales
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                color: "#666",
                textAlign: "justify",
                mb: 5,
              }}
            >
              Ofrecemos soluciones integrales de arrendamiento para equipos y
              materiales de construcción. Con nosotros, encontrarás maquinaria
              confiable, insumos de calidad y asesoría especializada para que tu
              proyecto avance sin contratiempos. Nuestro servicio está diseñado
              para optimizar costos y facilitar la gestión de recursos en obras
              de cualquier escala.
            </Typography>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#004aad",
                  borderRadius: "50px",
                  px: 3,
                  py: 1,
                  fontSize: "1rem",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#003b88" },
                }}
                href="/contactos"
              >
                Solicitar información
              </Button>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6} display="flex" justifyContent="center">
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true, amount: 0.3 }}
              style={{ width: "100%", maxWidth: 500 }}
            >
              <Box
                sx={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  src={require("../../static/media/services/Service1.webp")}
                  alt="Arrendamiento de Equipos y Materiales"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Leasing;
